import { createSelector } from 'reselect';

import { getProps } from 'utils/selectors';

/** @returns {import("../reducer/data/context").ConversationContextEntity} */
const getContextState = state => state.chat.data.context;

const getContextEntities = createSelector(getContextState, state => state.entities);

export const getContextById = createSelector(getContextEntities, getProps, (entities, id) => entities[id]);

export const getContextByIds = createSelector(
  getContextEntities,
  getProps,
  /** @param {string[]} ids  */
  (entities, ids = []) =>
    ids.reduce((acc, id) => {
      const entity = entities[id];
      if (entity) {
        return [...acc, entity];
      }
      return acc;
    }, [])
);
